import { AppState } from 'store/root.reducer'

export const selectUtilsState = (state: AppState) => state?.utils

export const selectCurrentTime = (state: AppState) => selectUtilsState(state)?.currentTime

export const selectLoadingCurrentTimeStatus = (state: AppState) => selectUtilsState(state)?.loadingStatus
